import { render, staticRenderFns } from "./DeleteTextModerationRulesModal.vue?vue&type=template&id=1c57941b&"
import script from "./DeleteTextModerationRulesModal.vue?vue&type=script&lang=js&"
export * from "./DeleteTextModerationRulesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports